module.exports = __webpack_public_path__ + "img/section3_img3.18cc43b2.png";